import { defineAsyncComponent } from 'vue';
import { AbstractModalService } from '@/core/modals/AbstractModalService';
import { ModalOptions, ModalOptionWidth } from '@/core/modals/ModalState';
import { AddressViewObject, DeliveryAddressViewObject } from '@/types/apiServerContract';

class CheckoutChangeAddressOverlayService extends AbstractModalService {
    public show(
        deliveryAddresses: DeliveryAddressViewObject[],
        deliveryAddress: AddressViewObject | DeliveryAddressViewObject | null,
        allowedCountryCodes: string[],
        options?: Partial<ModalOptions>
    ) {
        return this.showModal<DeliveryAddressViewObject>({
            component: defineAsyncComponent(() => import(
                '@/project/app/client-pages/checkout/addresses/CheckoutChangeAddressOverlay.vue')),
            componentAttrs: {
                deliveryAddresses,
                deliveryAddress,
                allowedCountryCodes
            },
            options: {
                width: ModalOptionWidth.Wide,
                usePanelWrapper: false,
                modalBodyWrapClass: 'lg:bg-white rounded-8',
                showCloseButton: true,
                disableUserClose: true,
                contentMaxHeight: false,
                closeOnBreakpointChange: true,
                ...options
            }
        });
    }
}

export default new CheckoutChangeAddressOverlayService();
